import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { inject, observer } from 'mobx-react';

import TiaoStore from '../../stores/TiaoStore';

class ExternalHTML extends Component {
  async componentDidMount() {
    const {
      component,
      tiaoStore: { getHtml },
    } = this.props;

    await getHtml(component);
  }

  render() {
    const {
      component,
      tiaoStore: { html },
    } = this.props;

    return <div dangerouslySetInnerHTML={{ __html: html[component] }} />;
  }
}

ExternalHTML.propTypes = {
  component: PropTypes.oneOf(['header', 'footer']).isRequired,
  tiaoStore: PropTypes.instanceOf(TiaoStore).isRequired,
};

export default inject('tiaoStore')(observer(ExternalHTML));
